export const paths = {
	root: '/gapPacketManagement',
    gapPacketList: '/gapPacketManagement/gapPacketList',
    actions: {
        createGapPacket: '/gapPacketManagement/createGapPacket'
    },
    acknowledge: '/gapPacketManagement/acknowledge',
    // 18740 - Added reporting for Gap Packet
    details: {
        gapPacketReport: '/gapPacketManagement/reports'
    }        
};